import { AppState } from 'services/types';
import { FertilizerEventStartDate } from 'services/fertilizerEvents/types';
import {
    AppliedFertilizerEntitiesByDateRequestProps,
    AppliedFertilizerEntitiesByDateState
} from './types';

const selectStartDate = (
    state: AppState,
    props: AppliedFertilizerEntitiesByDateRequestProps
): FertilizerEventStartDate => props.startDate;

const selectAppliedFertilizerEntitiesByDate = (
    state: AppState
): AppliedFertilizerEntitiesByDateState =>
    state.appliedFertilizerEntitiesByDate;

export { selectStartDate, selectAppliedFertilizerEntitiesByDate };
